import { phoneNumberformat } from "@lib/util/format-phone-number"
import ReadonlyRating from "@modules/common/components/readonly-rating"
import { H4 } from "@modules/common/components/typography/H4"
import { P } from "@modules/common/components/typography/P"
import { YelpLogo } from "@modules/common/components/yelp-logo/yelp-logo"
import { Coordinates, Location } from "types/business"
import GoogleMapsLink from "./google-maps-link"
import { CHOOSE_YOUR_OWN, LET_THEM_CHOOSE, SearchService } from "@lib/constants/variants"
import { GiftCardTypes } from "./giftcard-type"
import { GoogleRating } from "@modules/common/components/google-rating"
import { GoogleLogo } from "@modules/common/components/google-logo"
import { useSearchService } from "@lib/context/search-service-context"
import { getFeatureFlagState } from "@lib/data"
import { featureFlags } from "@lib/constants/network-constants"
import { useEffect, useState } from "react"

type Props = {
  id?: string;
  rating: number
  review_count: number
  name: string
  location: Location
  phone: string
  coordinates: Coordinates,
  distance: number,
  url: string,
  search_provider: string,
}

const MediumGiftCardInformation = ({ ...props }: Props) => {
  const { rating, review_count, name, location, phone, coordinates, distance, url, id, search_provider } = props;
  const searchService = useSearchService();
  const [pointMode, setPointMode] = useState<boolean>(false);

  useEffect(() => {
  const fetchPointMode = async () => {
    const result = await getFeatureFlagState(featureFlags.ENABLE_SERVICE_PROVIDERS);
    setPointMode(result);
  };

  fetchPointMode();
  }, []);

  return (
    <div>
      {!searchService?.loading && <div className="flex mt-1 space-x-1.5 items-center">
        {id && <><a href={url} target="blank" aria-label="go to business">
          {search_provider === SearchService.YELP ? <ReadonlyRating count={rating} size="1rem" /> :
            <GoogleRating count={rating} size="1rem" />
          }
        </a>
          <div className="flex space-x-1 items-center">
            <H4 className="text-base"><a href={url} target="blank">{rating}</a></H4>
            <a href={url} target="blank"><span className="flex text-base text-gray-ada items-center">
              ({review_count}) on <span className="ml-2">
                {search_provider === SearchService.YELP ?
                  <YelpLogo /> :
                  <GoogleLogo />
                }</span>
            </span></a>
          </div>
        </>}
      </div>}
      {name === LET_THEM_CHOOSE ? <H4 className="text-xl mt-1 uppercase mb-4">{CHOOSE_YOUR_OWN}</H4> : <H4 className={`text-xl mt-1 ${!id ? 'uppercase mb-4' : ''}`}>{name}</H4>}
      {name === LET_THEM_CHOOSE ? <GiftCardTypes /> : ''}
      {id &&
        <div className="mt-1">
          <P>{location?.display_address?.join(", ")} {distance ? `MO ${Math.round(distance)}` : ''}</P>
          <p className="font-normal text-black text-base">
            <GoogleMapsLink id={id} search_provider={search_provider} coordinates={coordinates} mapUrl={url} />
            {phoneNumberformat(phone)}
          </p>
        </div>
      }
    </div>
  )
}

export default MediumGiftCardInformation
